<style>
  .vue-daterange-picker .ranges {
    float: right;
    border-left: 1px solid #ddd;
  }
  .daterangepicker {
    border-left: none !important;
  }
</style>
<template>
<div id="demo-basic-card">
 <div id="dashboard-analytics">
    <div class="vx-row">
        <div class="vx-col w-full mb-2" style="margin-top:-24px">
          <vx-card class="p-1" :headerPadding="true">
            <div class="vx-row">
            <div class=" pl-5 mt-1 md:w-5/6" >
                <span>Thời gian: </span>
                <date-range-picker
                  ref="picker"
                  :locale-data="{format: 'dd/mm/yyyy' }"
                  :opens="'right'"
                  @update="updateValues"
                  v-model="dateRange">
                </date-range-picker>
              </div>
            <div class="vx-col md:w-1/6 w-full mt-1 pr-4">
              <div class="w-full" style="float:right">
                <vs-button style="border-radius:20px;float:right"
                         @click="downloadFile"
                         icon-pack="feather"
                         icon="icon-plus-circle">
                Tạo báo cáo
              </vs-button>
              </div>
            </div>
          </div>
          </vx-card>
        </div>
      </div>
    <div class="vx-row">
    <div class="vx-col md:w-1/3">
      <div class="vx-card">
                  <div class="mb-2 pb-2 m-auto" style="width:28.2rem;">
                     <div class="vx-row">
                      <span class="title feather-icon select-none relative" style="margin-left:20px"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" :fill="colorDefault" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle h-24 w-24"><circle cx="12" cy="12" r="10"></circle></svg></span>
                      <h1 class="header-title title mt-8" style="color: rgba(51,102,255,0.85); font-size: 30px">Mạng xã hội</h1>
                      <span v-if="totalSocialNetwork != 0" class="title feather-icon select-none relative ml-2"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 0 24 24" :fill="colorSocial" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                    </div>
                    <div class="vx-row">
                        <span class="ml-24" style="font-size: 16px">Nhắc đến</span>
                    </div>
                    <div class="vx-row">
                      <h1 class="color-data ml-24">{{totalSocialNetwork.toLocaleString()}}</h1>
                      <div class="vx-row color-green" v-if="increaseSocial && totalSocialNetwork != 0 && percentSocial !=undefined">
                          <span style="margin-top: 15px; font-size: 25px; margin-left: 20px;" >{{percentSocial}}</span>
                          <span style="margin-top: 15px; font-size: 25px;">%</span>
                          <feather-icon style="margin-left: 5px" icon="TrendingUpIcon"></feather-icon>
                      </div>
                      <div class="vx-row reduction" v-if="!increaseSocial && totalSocialNetwork != 0">
                          <span style="margin-top: 30px; font-size: 15px; margin-left: 20px;">{{percentSocial}}</span>
                          <span style="margin-top: 30px; font-size: 15px;">%</span>
                          <feather-icon style="margin-left: 5px;margin-top:15px; width:1rem" icon="TrendingDownIcon"></feather-icon>
                      </div>
                    </div>
                    <div class="vx-row">
                      <span class="title feather-icon select-none relative ml-24"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="#1aff1a" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                      <span style="font-size: 16px">Tích cực: <b style="color: #2c2c2c; margin-left: 5px">{{shade.totalPositiveSocialNetwork ? shade.totalPositiveSocialNetwork.toLocaleString() : 0}}</b></span>
                    </div>
                    <div class="vx-row">
                      <span class="title feather-icon select-none relative ml-24"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="#f4b401" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                      <span style="font-size: 16px">Trung lập: <b style="color: #2c2c2c; margin-left: 5px">{{shade.totalNeutralSocialNetwork ? shade.totalNeutralSocialNetwork.toLocaleString() : 0}}</b></span>
                    </div>
                    <div class="vx-row">
                      <span class="title feather-icon select-none relative ml-24"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="red" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                      <span style="font-size: 16px">Tiêu cực: <b style="color: #2c2c2c; margin-left: 5px">{{shade.totalNegativeSocialNetwork ? shade.totalNegativeSocialNetwork.toLocaleString() : 0}}</b></span>
                    </div>
                  </div>
      </div>
    </div>
    <div class="vx-col md:w-2/3">
      <ArticleDetail
        :initial="true"
        :fromDate="from"
        :toDate="to"
        :showTopic="'false'"
        :showNewsPost="'false'"
        :labelSocial="true"
        :labelNews="false"
        :getAll="false"
        :facePost="true"
        :faceComment="true"
        :newsPost="false"
        :showFilterCase="true"
      ></ArticleDetail>
    </div>
  </div>
 </div>
</div>
</template>
<script>
import ArticleDetail from './ArticleDetail.vue'
import moment from "moment";
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
export default {
  components:{
    ArticleDetail,
    Datepicker,
    DateRangePicker
  },
  data(){
    return{
        refresh: 0,
        colorDefault: "rgba(51,102,255,0.85)",
        colorSocial: "",
        colorNews: "",
        colorOther: "",
        showSourceDataChartLine: false,
        heightChartTopic: 250,
        shade: {},
        totalSocialNetwork: 0,
        increaseSocial: true,
        percentSocial: 0,
        totalNews: 0,
        increaseNews: true,
        percentNews: 0,
        totalOther: 0,
        increaseOther: true,
        percentOther: 0,
        mention: {},
        topPost: {},
        to: new Date(),
        from: (() => { let date = new Date (); date.setDate(date.getDate() - 7); date.setHours(0,0,0); return date})(),

        //popup
        popupActive:false,
        formData:{
          title:null,
          name:null,
          url:null,
          fullContents:null,
          datePublish:null,
          img:null
        },
        dateRange: {
          endDate: new Date(),
          startDate: (() => { let date = new Date ();
            date.setDate(date.getDate() - 6);
            date.setHours(0,0,0);
            return date
          })()
        },
        to: new Date(),
        from: (() => { let date = new Date ();
          date.setDate(date.getDate() - 7);
          date.setHours(0,0,0);
          return date })(),
    }
  },
  methods:{
     getShade() {
        let conditions = {
          to: this.to,
          from: this.from
        };
        this.$vs.loading();
        this.$processor.post('/user-data/get-shade', conditions).then((shade) => {
          this.shade = shade.data;
          if(this.shade.totalSocialFrom < this.shade.totalSocialTo) {
            this.increaseSocial = true;
            this.percentSocial = "+" + (((this.shade.totalSocialTo - this.shade.totalSocialFrom) / (this.shade.totalSocialFrom ? this.shade.totalSocialFrom : 1)) * 100).toFixed(2);
          } else {
            this.increaseSocial = false;
            this.percentSocial = "-" + (((this.shade.totalSocialFrom - this.shade.totalSocialTo) / (this.shade.totalSocialTo ? this.shade.totalSocialTo : 1)) * 100).toFixed(2);
          }
          if(this.shade.totalPositiveSocialNetwork > this.shade.totalNegativeSocialNetwork) {
            this.colorSocial = "#1aff1a"
            if(this.shade.totalPositiveSocialNetwork < this.shade.totalNeutralSocialNetwork) this.colorSocial = "#f4b401"
          } else {
            this.colorSocial = "red"
            if(this.shade.totalNegativeSocialNetwork < this.shade.totalNeutralSocialNetwork) this.colorSocial = "#f4b401"
          }
          let that = this;
          this.totalSocialNetwork = this.shade.totalPositiveSocialNetwork + this.shade.totalNegativeSocialNetwork + this.shade.totalNeutralSocialNetwork;

          if(this.shade.totalNewsFrom < this.shade.totalNewsTo) {
            this.increaseNews = true;
            this.percentNews = "+" + (((this.shade.totalNewsTo - this.shade.totalNewsFrom) / (this.shade.totalNewsFrom ? this.shade.totalNewsFrom : 1)) * 100).toFixed(2);
          } else {
            this.increaseNews = false;
            this.percentNews = "-" + (((this.shade.totalNewsFrom - this.shade.totalNewsTo) / (this.shade.totalNewsTo ? this.shade.totalNewsTo : 1)) * 100).toFixed(2);
          }
          if(this.shade.totalPositiveNews > this.shade.totalNegativeNews) {
            this.colorNews = "#1aff1a"
            if(this.shade.totalPositiveNews < this.shade.totalNeutralNews) this.colorNews = "#f4b401"
          } else {
            this.colorNews = "red"
            if(this.shade.totalNegativeNews < this.shade.totalNeutralNews) this.colorNews = "#f4b401"
          }
          this.totalNews = this.shade.totalPositiveNews + this.shade.totalNegativeNews + this.shade.totalNeutralNews;

          if(this.shade.totalOtherFrom < this.shade.totalOtherTo) {
            this.increaseOther = true;
            this.percentOther = "+" + (((this.shade.totalOtherTo - this.shade.totalOtherFrom) / (this.shade.totalOtherFrom ? this.shade.totalOtherFrom : 1)) * 100).toFixed(2);
          } else {
            this.increaseOther = false;
            this.percentOther = "-" + (((this.shade.totalOtherFrom - this.shade.totalOtherTo) / (this.shade.totalOtherTo ? this.shade.totalOtherTo : 1)) * 100).toFixed(2);
          }
          if(this.shade.totalPositiveOther > this.shade.totalNegativeOther) {
            this.colorOther = "#1aff1a"
            if(this.shade.totalPositiveOther < this.shade.totalNeutralOther) this.colorOther = "#f4b401"
          } else {
            this.colorOther = "red"
            if(this.shade.totalNegativeOther < this.shade.totalNeutralOther) this.colorOther = "#f4b401"
          }
          this.totalOther = this.shade.totalPositiveOther + this.shade.totalNegativeOther + this.shade.totalNeutralOther;
          this.$vs.loading.close();
        }).catch((err) => {
        });
      },
      getListTopic:function(){
        const payload ={};
        return new Promise((resolve, reject) => {
          this.$business.post('/topic/find-by-conditions',payload).then((response) =>{
            this.optionalsTopic = response.data;
            this.userTopics = response.data;
            resolve();
          })
            .catch(() =>{reject()})
        })
      },
       getTopPost() {
        let conditions = {
          to: this.to,
          from: this.from
        };
        this.showSourceDataChartLine = false;
        this.$vs.loading();
        this.$processor.post('/user-data/get-top-post', conditions).then((topPost) => {
          if(topPost.data && topPost.data.topPostSocial.length > 0) {
            topPost.data.topPostSocial = topPost.data.topPostSocial.slice(0,5);
            topPost.data.topPostSocial.forEach(el => {
              this.changeContent(el);
            });
          }
          if(topPost.data && topPost.data.topPostNews.length > 0) {
            topPost.data.topPostNews = topPost.data.topPostNews.slice(0,5);
            topPost.data.topPostNews.forEach(el => {
              this.changeContent(el);
            });
          }
          if(topPost.data && topPost.data.topPostOther.length > 0) {
            topPost.data.topPostOther = topPost.data.topPostOther.slice(0,5);
            topPost.data.topPostOther.forEach(el => {
              this.changeContent(el);
            });
          }
          this.topPost = topPost.data;
          this.$vs.loading.close();
        }).catch((err) => {
        });
      },
      formatDate(val){
        return moment(val).format("DD/MM/YYYY");
      },
      downloadFile(){},
      updateValues(){
        this.initScreen();
      },
      initScreen(){
        this.from = this.dateRange.startDate
        this.to = this.dateRange.endDate
        this.getListTopic().then(v => {
          this.getTopPost();
        })
        this.getShade();
      }
  },
  async created(){
    this.refresh += 1;
    // let datefrom = new Date();
    //   datefrom.setDate(datefrom.getDate() - 7);
    //   this.to = new Date();
    //   this.from = datefrom;

    this.initScreen()
  },
}
</script>
<style scoped>
 .color-green {
    color: #1aff1a
}
.color-red {
    color: red;
}
.reduction {
    color: red;
  }
.color-data {
    font-size: 50px;
    font-weight: bold
}
</style>
